module.exports = __webpack_public_path__ + "fonts/GothamSSm-Medium.e79be56e.woff2";